import * as AccessibleIcon from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

const Store: React.FC<SVGProps<SVGSVGElement>> = props => {
  const label = 'custom-icon' // Remplacez par un label approprié
  return (
    <AccessibleIcon.Root label={label}>
      <svg
        width="22"
        height="20"
        viewBox="0 0 22 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
          d="M21 18V20H1V18H2V11.242C1.38437 10.8311 0.879713 10.2745 0.53082 9.62176C0.181927 8.96899 -0.000407734 8.24017 6.84612e-07 7.5C6.84612e-07 6.673 0.224001 5.876 0.633001 5.197L3.345 0.5C3.43277 0.347985 3.559 0.221749 3.71101 0.133981C3.86303 0.0462129 4.03547 4.45922e-06 4.211 0H17.79C17.9655 4.45922e-06 18.138 0.0462129 18.29 0.133981C18.442 0.221749 18.5682 0.347985 18.656 0.5L21.358 5.182C21.9546 6.17287 22.1463 7.35553 21.8934 8.48414C21.6405 9.61275 20.9624 10.6005 20 11.242V18H21ZM4.789 2L2.356 6.213C2.11958 6.79714 2.11248 7.44903 2.33613 8.03818C2.55978 8.62733 2.99768 9.11029 3.56218 9.39039C4.12668 9.6705 4.77614 9.72708 5.38058 9.54882C5.98502 9.37055 6.49984 8.9706 6.822 8.429C7.157 7.592 8.342 7.592 8.678 8.429C8.8633 8.89342 9.1836 9.2916 9.59753 9.5721C10.0115 9.85261 10.5 10.0025 11 10.0025C11.5 10.0025 11.9885 9.85261 12.4025 9.5721C12.8164 9.2916 13.1367 8.89342 13.322 8.429C13.657 7.592 14.842 7.592 15.178 8.429C15.3078 8.74845 15.5022 9.0376 15.7491 9.27828C15.996 9.51895 16.2901 9.70595 16.6127 9.82752C16.9354 9.94909 17.2797 10.0026 17.6241 9.98468C17.9684 9.96677 18.3053 9.87782 18.6136 9.72343C18.9219 9.56903 19.1949 9.35253 19.4155 9.08753C19.6361 8.82253 19.7995 8.51477 19.8955 8.18357C19.9914 7.85238 20.0178 7.50493 19.973 7.16305C19.9281 6.82118 19.8131 6.49227 19.635 6.197L17.21 2H4.79H4.789Z"
          fill="#1A0244"
        />
      </svg>
    </AccessibleIcon.Root>
  )
}

export default Store
